import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useClassroomSessionStore } from "stores/v2/classroomSessionStore";
import { useTranslation } from "react-i18next";

const StartMonitoringButton = React.memo((props) => {
	const { t } = useTranslation();
	const handleClick = (ev) => {
		ev.stopPropagation();
		if (props.disabled) return;
		useClassroomSessionStore.getState().handleShowStartClassModal({
			show: true,
			classroomName: props.classroomName,
			monitoring: true,
		});
	};

	return (
		<button
			type="button"
			className={clsx("button-callToAction--green Classroom_start--wide", "Classroom_sart--monitor")}
			onClick={handleClick}
			disabled={props.disabled}
			style={props.disabled ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
		>
			{t("classroomDetails.startMonitoring")}
		</button>
	);
});
StartMonitoringButton.displayName = "StartMonitoringButton";

StartMonitoringButton.propTypes = {
	classroomName: PropTypes.string,
	disabled: PropTypes.bool,
};

export default StartMonitoringButton;
